import React, { useState, useCallback, useContext } from "react";
import CustomDropDown from "../../Common/CustomDropDown";
import styled from "styled-components";
import EditPic from "../../../SVGs/Edit.svg";
import CustomTextField from "../../Common/CustomTextField";
import toast from "react-hot-toast";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import Cookies from "js-cookie";
import { UserContext } from "../../../Context/user_context";
import PageLoader from "../../Common/PageLoader";

function GeneralInformationSection({
  submitPass,
  setSubmitPass,
  employmentPass,
  setEmploymentPass,
  setMessage,
  setError,
  setData,
  data,
  contactId,
  refetchData,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const { user, setUser } = useContext(UserContext);

  const Options = [
    {
      key: 100000000,
      value: 100000000,
      text: "Dr",
    },
    {
      key: 100000001,
      value: 100000001,
      text: "Mr",
    },
    {
      key: 100000002,
      value: 100000002,
      text: "Ms",
    },
    {
      key: 100000003,
      value: 100000003,
      text: "Mrs",
    },
  ];

  const Genders = [
    {
      key: 1,
      value: 1,
      text: "Male",
    },
    {
      key: 2,
      value: 2,
      text: "Female",
    },
  ];

  const Pronouns = [
    {
      key: 0,
      value: 0,
      text: "He/Him",
    },
    {
      key: 1,
      value: 1,
      text: "She/Her",
    },
    {
      key: 2,
      value: 2,
      text: "They/Them",
    },
  ];
  
  const MaritalStatus = [
    {
      key: 910310004,
      value: 910310004,
      text: "Life Partner",
    },
    {
      key: 2,
      value: 2,
      text: "Married",
    },
    {
      key: 1,
      value: 1,
      text: "Single",
    },
    {
      key: 3,
      value: 3,
      text: "Divorced",
    },
    {
      key: 910310000,
      value: 910310000,
      text: "Remarried",
    },
    {
      key: 4,
      value: 4,
      text: "Widowed",
    },
    {
      key: 910310001,
      value: 910310001,
      text: "Engaged",
    },
    {
      key: 910310002,
      value: 910310002,
      text: "Separated",
    },
    {
      key: 910310003,
      value: 910310003,
      text: "Divorced-Newly Engaged",
    },
  ];

  const [generalInformation, setGeneralInfomration] = useState(false);
  const [title, setTitle] = useState(data ? data.new_title : "");
  const [preferredFirstName, setPreferredFirstName] = useState(
    data ? data.hip_preferredfirstname : ""
  );
  const [birthday, setBirthday] = useState(data ? data.birthdate : "");
  const [gender, setGender] = useState(data ? data.gendercode : "");
  const [pronouns, setPronouns] = useState(data ? data.hip_pronouns : "");
  const [legalFirstName, setLegalFirstName] = useState(
    data ? data.firstname : ""
  );
  const [maritalStatus, setMaritalStatus] = useState(
    data ? data.familystatuscode : ""
  );
  const [legalLastName, setLegalLastname] = useState(data ? data.lastname : "");

  const handleGeneralInformation = useCallback(() => {
    setGeneralInfomration(!generalInformation);
  }, [generalInformation]);

  const handleUpdateRecord = async () => {
    if (!title || !birthday || !legalFirstName || !legalLastName) {
      console.log(title, birthday, legalFirstName, legalLastName);
      toast.error(
        "Please fill in all required fields: Title, Birthdate, First Name, and Last Name"
      );
      return;
    }

    const userid = contactId
      ? contactId
      : Cookies.get("hippocratic_portal_contactid");
    const recordData = {
      entity: "contacts",
      id: userid,
      attributes: [
        {
          fieldname: "new_title",
          value: title,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "gendercode",
          value: gender,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "hip_pronouns",
          value: pronouns,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "familystatuscode",
          value: maritalStatus,
          type: "string",
          entity: null,
        },
        {
          fieldname: "birthdate",
          value: birthday,
          type: "date",
          entity: null,
        },
        {
          fieldname: "lastname",
          value: legalLastName,
          type: "string",
          entity: null,
        },
        {
          fieldname: "firstname",
          value: legalFirstName,
          type: "string",
          entity: null,
        },
        {
          fieldname: "hip_preferredfirstname",
          value: preferredFirstName,
          type: "string",
          entity: null,
        },
        ...(user.hip_initialportalinfoupdate
          ? []
          : [
              {
                fieldname: "hip_initialportalinfoupdate",
                value: "910310000",
                type: "optionset",
                entity: null,
              },
            ]),
      ],
    };

    try {
      setIsLoading(true);
      if (data.new_title === 100000000) {
        setSubmitPass(true);
      }
      setTimeout(
        () => {
          getApiClient()
            .updateRecord(recordData)
            .then((res) => {
              if (res) {
                setError("");
                if (res.data && refetchData) {
                  refetchData();
                }
                setEmploymentPass(false);
                toast.success("Information has been updated successfully");
                setMessage("");
                setGeneralInfomration(!generalInformation);
              }
            })
            .catch((error) => {
              console.log(error);
              setMessage("");
              setError(
                "If title is Doctor, at least one of Residency Program, Residency Completion, Fellowship Program, or Fellowship Completed must be filled in."
              );
            })
            .finally(() => {
              setIsLoading(false);
              setSubmitPass(false);
            });
        },
        employmentPass ? 500 : 0
      );
      if (!user.hip_initialportalinfoupdate) {
        setUser({
          ...user,
          hip_initialportalinfoupdate: true,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleTitleChange = useCallback(
    (value) => {
      setTitle(value);
      if (value === 100000000) {
        setMessage(
          "Please fill in one of the following fields: Residency Program, Residency Completion, Fellowship Program, or Fellowship Completion"
        );
        setError("");
        setEmploymentPass(true);
      } else {
        setError("");
        setMessage("");
        setEmploymentPass(false);
      }
      setData({
        ...data,
        new_title: value,
      });
    },
    [data, setError, setMessage, setEmploymentPass]
  );

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Sectoin>
        <TopPart>
          <SubTitle>General Information</SubTitle>
          {generalInformation ? (
            <Save onClick={handleUpdateRecord}>Save Changes</Save>
          ) : (
            <Edit
              onClick={() => {
                handleGeneralInformation();
              }}
            >
              Edit
              <img style={{ height: "19px" }} src={EditPic} alt="edit-icon" />
            </Edit>
          )}
        </TopPart>
        <BottomPart>
          <CustomDropDown
            Active={generalInformation}
            options={Options}
            Title="Title *"
            value={title}
            onChange={handleTitleChange}
            required
          />
          <CustomTextField
            Active={false}
            Title="Legal First Name: *"
            value={legalFirstName}
            onChange={setLegalFirstName}
            required
            readOnly
          />
          <CustomTextField
            Active={false}
            Title="Legal Last Name: *"
            value={legalLastName}
            onChange={setLegalLastname}
            required
            readOnly
          />
          <CustomTextField
            Active={generalInformation}
            Title="Preferred First Name:"
            value={preferredFirstName}
            onChange={setPreferredFirstName}
          />
          <CustomDropDown
            Active={generalInformation}
            options={Genders}
            Title="Gender:"
            value={gender}
            onChange={setGender}
          />
          <CustomDropDown
            Active={generalInformation}
            options={Pronouns}
            Title="Pronouns:"
            value={pronouns}
            onChange={setPronouns}
          />
          <CustomTextField
            Active={generalInformation}
            Type="date"
            Title="Birthday: *"
            value={birthday}
            onChange={setBirthday}
            required
          />
          <CustomDropDown
            Active={generalInformation}
            options={MaritalStatus}
            Title="Marital Status:"
            value={maritalStatus}
            onChange={setMaritalStatus}
          />
        </BottomPart>
      </Sectoin>
    </>
  );
}

const Sectoin = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
`;

const TopPart = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const Edit = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #87a9bf;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: italic;
  font-weight: 300;
  line-height: 10px;
  text-decoration-line: underline;
`;

const BottomPart = styled.div`
  display: grid;
  min-height: 100px;
  gap: 30px;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-items: center;
  @media screen and (max-width: 450px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`;

const SubTitle = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const Save = styled.div`
  border-radius: 300px;
  background: #304961;
  padding: 5px 10px;

  cursor: pointer;

  white-space: nowrap;

  color: #fff;
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`;

export default GeneralInformationSection;
